

import React, { useEffect, useMemo, useState } from "react";


import I from "../component/Icon";



import apiService from "../services/apiService";

const REPORT_API = "Report/allReportsQueryReport";

const PAGE_SIZE = 10;

const REPORT_CONFIGS = {
    GetDistrictWiseSchoolReport: {
        name: "District Wise School Report",
        studentId: 0,
        columns: [
            { key: "schoolName", label: "School Name", minWidth: 220 },
            { key: "districtName", label: "District Name", minWidth: 180 },
            { key: "talukaName", label: "Taluka Name", minWidth: 180 },
            { key: "stateName", label: "State Name", minWidth: 180 },
        ],
    },


    // Columns are based on GetStudentBookAssignReport's reportColumns/reportData response.
    GetStudentBookAssignReport: {
        name: "Student Book Assign Report",
        studentId: 3,
        columns: [
            { key: "studentName", label: "Student Name", minWidth: 185 },
            { key: "competitiveExams", label: "Competitive Exams", minWidth: 165 },
            { key: "bookName", label: "Book Name", minWidth: 185 },
            { key: "examTotalFees", label: "Exam Total Fees", minWidth: 140 },
            { key: "feesPaid", label: "Fees Paid", minWidth: 115 },
            { key: "pendingFees", label: "Pending Fees", minWidth: 135 },
            { key: "postTrackNo", label: "Post Tracking No", minWidth: 170 },
            { key: "bookPostStatus", label: "Book Post Status", minWidth: 165 },
        ],
    },



    GetTeacherWiseBookAssignReport: {



        name: "Teacher Wise Book Assign Report",



        studentId: 0,



        columns: [



            { key: "teacherName", label: "Teacher Name", minWidth: 190 },



            { key: "schoolName", label: "School Name", minWidth: 210 },



            { key: "bookName", label: "Book Name", minWidth: 150 },



            { key: "amount", label: "Amount", minWidth: 120 },



            { key: "qty", label: "Qty", minWidth: 100 },



            { key: "returnAmount", label: "Return Amount", minWidth: 145 },



            { key: "returnQty", label: "Return Qty", minWidth: 120 },



            { key: "createdBy", label: "Created By", minWidth: 120 },



            { key: "createdDate", label: "Created Date", minWidth: 145 },



        ],



    },



    GetAllPaymentsReport: {



        name: "Payments Report",



        studentId: 3,



        columns: [



            { key: "studentName", label: "Student Name", minWidth: 180 },



            { key: "schoolName", label: "School Name", minWidth: 210 },



            { key: "examName", label: "Exam Name", minWidth: 180 },



            { key: "orderAmount", label: "Order Amount", minWidth: 130 },



            { key: "paidAmount", label: "Paid Amount", minWidth: 120 },



            { key: "pendingAmount", label: "Pending Amount", minWidth: 140 },



            { key: "paymentStatus", label: "Payment Status", minWidth: 135 },



            { key: "paymentReference", label: "Payment Reference", minWidth: 190 },



            { key: "createdBy", label: "Created By", minWidth: 120 },



            { key: "createdDate", label: "Created Date", minWidth: 165 },



        ],



    },



    GetAllPendingPaymentsReport: {



        name: "Pending Payments Report",



        studentId: 3,



        columns: [



            { key: "studentName", label: "Student Name", minWidth: 180 },



            { key: "schoolName", label: "School Name", minWidth: 210 },



            { key: "examName", label: "Exam Name", minWidth: 180 },



            { key: "orderAmount", label: "Order Amount", minWidth: 130 },



            { key: "pendingAmount", label: "Pending Amount", minWidth: 140 },



            { key: "paymentStatus", label: "Payment Status", minWidth: 135 },



            { key: "createdBy", label: "Created By", minWidth: 120 },



            { key: "createdDate", label: "Created Date", minWidth: 165 },



        ],



    },



    GetAllStudentsReport: {



        name: "Students Report",



        studentId: 3,



        columns: [



            { key: "studentName", label: "Student Name", minWidth: 180 },



            { key: "schoolName", label: "School Name", minWidth: 210 },



            { key: "examName", label: "Exam Name", minWidth: 180 },



            { key: "orderAmount", label: "Order Amount", minWidth: 130 },



            { key: "teacherName", label: "Teacher Name", minWidth: 180 },



            { key: "createdBy", label: "Created By", minWidth: 120 },



            { key: "createdDate", label: "Created Date", minWidth: 165 },



        ],



    },



};







const ADMIN_REPORT_OPTIONS = [
    "GetDistrictWiseSchoolReport",
    "GetStudentBookAssignReport",
    "GetTeacherWiseBookAssignReport",
    "GetAllPaymentsReport",



    "GetAllPendingPaymentsReport",



    "GetAllStudentsReport",



];







const STUDENT_REPORT_OPTIONS = [
    "GetStudentBookAssignReport",



    "GetAllStudentsReport",



    "GetAllPendingPaymentsReport",



    "GetAllPaymentsReport",



];







const getTodayValue = () => {







    const now = new Date();







    const year = now.getFullYear();







    const month = String(now.getMonth() + 1).padStart(2, "0");







    const day = String(now.getDate()).padStart(2, "0");















    return `${year}-${month}-${day}`;







};















const getMonthStartValue = () => {







    const now = new Date();







    const year = now.getFullYear();







    const month = String(now.getMonth() + 1).padStart(2, "0");















    return `${year}-${month}-01`;







};















const formatDate = (value) => {







    if (!value) return "";















    const parts = String(value).substring(0, 10).split("-");















    if (parts.length === 3) {







        return `${parts[2]}/${parts[1]}/${parts[0]}`;







    }















    return value;







};















const FilterIcon = ({ size = 15 }) => (







    <svg







        width={size}







        height={size}







        viewBox="0 0 24 24"







        fill="none"







        stroke="currentColor"







        strokeWidth="2"







        strokeLinecap="round"







        strokeLinejoin="round"







        aria-hidden="true"







    >







        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />







    </svg>







);















const DownloadIcon = ({ size = 15 }) => (







    <svg







        width={size}







        height={size}







        viewBox="0 0 24 24"







        fill="none"







        stroke="currentColor"







        strokeWidth="2"







        strokeLinecap="round"







        strokeLinejoin="round"







        aria-hidden="true"







    >







        <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4" />







        <polyline points="7 10 12 15 17 10" />







        <line x1="12" y1="15" x2="12" y2="3" />







    </svg>







);























const getStoredUser = () => {







    const storageValues = [







        sessionStorage.getItem("user"),







        localStorage.getItem("user"),







    ];















    for (const rawValue of storageValues) {







        if (!rawValue) continue;















        try {







            const parsed = JSON.parse(rawValue);















            if (parsed && typeof parsed === "object") {







                return parsed;







            }







        } catch {







            // Keep checking the remaining storage values.







        }







    }















    return {};







};















const getRoleFromToken = () => {



    const token =



        sessionStorage.getItem("token") ||



        localStorage.getItem("token") ||



        sessionStorage.getItem("jwtToken") ||



        localStorage.getItem("jwtToken") ||



        "";







    if (!token) return "";







    try {



        const cleanToken = String(token)



            .replace(/^Bearer\s+/i, "")



            .replace(/^"|"$/g, "")



            .trim();







        const parts = cleanToken.split(".");



        if (parts.length !== 3) return "";







        const base64Url = parts[1];



        const base64 = base64Url.replace(/-/g, "+").replace(/\_/g, "/");



        const paddedBase64 = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");







        const payload = JSON.parse(



            decodeURIComponent(



                atob(paddedBase64)



                    .split("")



                    .map(



                        (character) =>



                            `%${("00" + character.charCodeAt(0).toString(16)).slice(-2)}`



                    )



                    .join("")



            )



        );







        const roleValue =



            payload?.role ??



            payload?.Role ??



            payload?.roleName ??



            payload?.RoleName ??



            payload?.["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"] ??



            payload?.["http://schemas.xmlsoap.org/ws/2005/05/identity/claims/role"] ??



            "";







        return Array.isArray(roleValue)



            ? roleValue.join(",")



            : String(roleValue || "");



    } catch {



        return "";



    }



};







const getLoggedInRole = () => {







    const storedUser = getStoredUser();















    const roleValue =







        sessionStorage.getItem("role") ||







        localStorage.getItem("role") ||







        storedUser?.role ||







        storedUser?.Role ||







        storedUser?.roleName ||







        storedUser?.RoleName ||







        getRoleFromToken() ||







        "";















    if (Array.isArray(roleValue)) {







        return roleValue.join(",");







    }















    return String(roleValue || "");







};















const getTeacherIdFromObject = (value) => {







    if (!value || typeof value !== "object") {







        return "";







    }















    const directTeacherId =







        value?.teacherId ??







        value?.TeacherId ??







        value?.teacherID ??







        value?.TeacherID;















    if (







        directTeacherId !== undefined &&







        directTeacherId !== null &&







        directTeacherId !== ""







    ) {







        return String(directTeacherId);







    }















    const teacherObject =







        value?.teacher ??







        value?.Teacher;















    const nestedTeacherId =







        teacherObject?.teacherId ??







        teacherObject?.TeacherId ??







        teacherObject?.id ??







        teacherObject?.Id;















    if (







        nestedTeacherId !== undefined &&







        nestedTeacherId !== null &&







        nestedTeacherId !== ""







    ) {







        return String(nestedTeacherId);







    }















    const nestedValues = [







        value?.user,







        value?.User,







        value?.profile,







        value?.Profile,







        value?.data,







        value?.Data,







        value?.output,







        value?.Output,







    ];















    for (const nestedValue of nestedValues) {







        const nestedId =







            getTeacherIdFromObject(







                nestedValue







            );















        if (nestedId) {







            return nestedId;







        }







    }















    return "";







};















const getTeacherIdFromToken = () => {







    const token =







        sessionStorage.getItem("token") ||







        localStorage.getItem("token") ||







        sessionStorage.getItem("jwtToken") ||







        localStorage.getItem("jwtToken") ||







        "";















    if (!token) {







        return "";







    }















    try {







        const cleanToken =







            String(token)







                .replace(/^Bearer\s+/i, "")







                .replace(/^"|"$/g, "")







                .trim();















        const parts =







            cleanToken.split(".");















        if (parts.length !== 3) {







            return "";







        }















        const base64Url =







            parts[1];















        const base64 =







            base64Url







                .replace(/-/g, "+")







                .replace(/\_/g, "/");















        const paddedBase64 =







            base64.padEnd(







                Math.ceil(base64.length / 4) * 4,







                "="







            );















        const payload =







            JSON.parse(







                decodeURIComponent(







                    atob(paddedBase64)







                        .split("")







                        .map(







                            (character) =>







                                `%${(







                                    "00" +







                                    character







                                        .charCodeAt(0)







                                        .toString(16)







                                ).slice(-2)}`







                        )







                        .join("")







                )







            );















        return (







            payload?.teacherId ??







            payload?.TeacherId ??







            payload?.teacherID ??







            payload?.TeacherID ??







            ""







        ).toString();







    } catch {







        return "";







    }







};















const getLoggedInTeacherId = () => {







    const storedUser =







        getStoredUser();















    return (







        getTeacherIdFromObject(







            storedUser







        ) ||







        String(







            sessionStorage.getItem(







                "teacherId"







            ) ||







            localStorage.getItem(







                "teacherId"







            ) ||







            getTeacherIdFromToken() ||







            ""







        )







    );







};















const normalizePersonName = (value) =>







    String(value || "")







        .trim()







        .toLowerCase()







        .replace(/\./g, "")







        .replace(/\s+/g, " ");















const getLoggedInTeacherName = () => {







    const storedUser =







        getStoredUser();















    const storedFullName =







        sessionStorage.getItem("fullName") ||







        localStorage.getItem("fullName") ||







        storedUser?.fullName ||







        storedUser?.FullName ||







        "";















    if (storedFullName) {







        return String(storedFullName).trim();







    }















    const firstName =







        storedUser?.firstName ??







        storedUser?.FirstName ??







        "";















    const middleName =







        storedUser?.middleName ??







        storedUser?.MiddleName ??







        "";















    const lastName =







        storedUser?.lastName ??







        storedUser?.LastName ??







        "";















    return [







        firstName,







        middleName,







        lastName,







    ]







        .filter(Boolean)







        .join(" ")







        .trim();







};















const getStudentIdFromObject = (value) => {



    if (!value || typeof value !== "object") return "";







    const directStudentId =



        value?.studentId ?? value?.StudentId ?? value?.studentID ?? value?.StudentID;



    if (directStudentId !== undefined && directStudentId !== null && directStudentId !== "") {



        return String(directStudentId);



    }







    const studentObject = value?.student ?? value?.Student;



    const nestedStudentId =



        studentObject?.studentId ?? studentObject?.StudentId ?? studentObject?.id ?? studentObject?.Id;



    if (nestedStudentId !== undefined && nestedStudentId !== null && nestedStudentId !== "") {



        return String(nestedStudentId);



    }







    for (const nestedValue of [



        value?.user,



        value?.User,



        value?.profile,



        value?.Profile,



        value?.data,



        value?.Data,



        value?.output,



        value?.Output,



    ]) {



        const nestedId = getStudentIdFromObject(nestedValue);



        if (nestedId) return nestedId;



    }







    return "";



};







const getStudentIdFromToken = () => {



    const token =



        sessionStorage.getItem("token") ||



        localStorage.getItem("token") ||



        sessionStorage.getItem("jwtToken") ||



        localStorage.getItem("jwtToken") ||



        "";







    if (!token) return "";







    try {



        const cleanToken = String(token)



            .replace(/^Bearer\s+/i, "")



            .replace(/^"|"$/g, "")



            .trim();







        const parts = cleanToken.split(".");



        if (parts.length !== 3) return "";







        const base64Url = parts[1];



        const base64 = base64Url.replace(/-/g, "+").replace(/\_/g, "/");



        const paddedBase64 = base64.padEnd(Math.ceil(base64.length / 4) * 4, "=");



        const payload = JSON.parse(



            decodeURIComponent(



                atob(paddedBase64)



                    .split("")



                    .map((character) => `%${("00" + character.charCodeAt(0).toString(16)).slice(-2)}`)



                    .join("")



            )



        );







        return String(



            payload?.studentId ?? payload?.StudentId ?? payload?.studentID ?? payload?.StudentID ?? ""



        );



    } catch {



        return "";



    }



};







const getLoggedInStudentId = () => {
    const storedUser = getStoredUser();

    return String(
        sessionStorage.getItem("studentId") ||
        localStorage.getItem("studentId") ||
        sessionStorage.getItem("StudentId") ||
        localStorage.getItem("StudentId") ||
        getStudentIdFromObject(storedUser) ||
        getStudentIdFromToken() ||
        sessionStorage.getItem("userId") ||
        localStorage.getItem("userId") ||
        storedUser?.userId ||
        storedUser?.UserId ||
        storedUser?.id ||
        storedUser?.Id ||
        ""
    );
};







export default function ReportsPage({ reportType = "" }) {







    const loggedInRole =







        getLoggedInRole();















    const loggedInTeacherId =







        getLoggedInTeacherId();















    const loggedInTeacherName =







        getLoggedInTeacherName();







    const loggedInStudentId =



        getLoggedInStudentId();















    const normalizedRole =







        loggedInRole







            .toLowerCase()







            .replace(/\s+/g, "");















    const hasTeacherId =







        loggedInTeacherId !== "" &&







        loggedInTeacherId !== null &&







        loggedInTeacherId !== undefined &&







        !Number.isNaN(







            Number(loggedInTeacherId)







        );















    const numericTeacherId =







        hasTeacherId







            ? Number(loggedInTeacherId)







            : null;







    const hasStudentId =



        loggedInStudentId !== "" &&



        loggedInStudentId !== null &&



        loggedInStudentId !== undefined &&



        !Number.isNaN(Number(loggedInStudentId)) &&



        Number(loggedInStudentId) > 0;















    console.log("Logged In Student Id (resolved):", loggedInStudentId);


    /*
  
  
  
  
  
  
  
      Login-wise report access:
  
  
  
  
  
  
  
      - SuperAdmin TeacherId = 0 -> all report data
  
  
  
  
  
  
  
      - Teacher TeacherId > 0 -> only that teacher's data
  
  
  
  
  
  
  
    */







    // Admin/SuperAdmin must get all report records.



    // Explicit Student role always wins over TeacherId = 0 so student login



    // can never be treated as Admin/SuperAdmin.



    const roleSaysStudent = normalizedRole.includes("student");
    const roleSaysTeacher = normalizedRole.includes("teacher");
    const roleSaysAdmin = normalizedRole.includes("admin");

    /*
      Login-wise access:
      - Admin/SuperAdmin -> all records
      - Teacher -> actual logged-in TeacherId
      - Student -> actual logged-in StudentId
    */
    const isStudent =
        roleSaysStudent ||
        (!roleSaysAdmin && !roleSaysTeacher && hasStudentId);

    const isTeacher =
        !isStudent &&
        (
            roleSaysTeacher ||
            (hasTeacherId && numericTeacherId > 0)
        );

    const isSuperAdmin =
        !isStudent &&
        !isTeacher &&
        (
            roleSaysAdmin ||
            (hasTeacherId && numericTeacherId === 0)
        );





    const [selectedReportType, setSelectedReportType] = useState(() =>
        reportType ||
        (isStudent ? "GetAllStudentsReport" : "GetTeacherWiseBookAssignReport")
    );
    useEffect(() => {
        if (reportType && REPORT_CONFIGS[reportType]) {
            setSelectedReportType(reportType);
            setReportData([]);
            setGenerated(false);
            setFilters({});
            setPageNumber(1);
            setError("");
        }
    }, [reportType]);
    useEffect(() => {



        if (!reportType && isStudent && !STUDENT_REPORT_OPTIONS.includes(selectedReportType)) {



            setSelectedReportType("GetAllStudentsReport");



            setReportData([]);



            setGenerated(false);



            setFilters({});



            setPageNumber(1);



        }



    }, [reportType, isStudent, selectedReportType]);







    const selectedReport =



        REPORT_CONFIGS[selectedReportType] ??



        REPORT_CONFIGS.GetTeacherWiseBookAssignReport;







    const REPORT_NAME = selectedReport.name;



    const REPORT_TYPE = selectedReportType;



    const REPORT_COLUMNS = selectedReport.columns;







    const [fromDate, setFromDate] = useState(getMonthStartValue);







    const [toDate, setToDate] = useState(getTodayValue);







    const [generated, setGenerated] = useState(false);

    const [dateFilterApplied, setDateFilterApplied] = useState(false);







    const [showFilters, setShowFilters] = useState(true);







    const [filters, setFilters] = useState({});







    const [error, setError] = useState("");







    const [notification, setNotification] = useState(null);







    const showNotification = (type, message) => {



        setNotification({ type, message });



    };







    useEffect(() => {



        if (!notification) return undefined;



        const timer = setTimeout(() => setNotification(null), 3000);



        return () => clearTimeout(timer);



    }, [notification]);















    const [reportData, setReportData] =







        useState([]);















    const [loading, setLoading] =







        useState(false);















    const [pageNumber, setPageNumber] =







        useState(1);















    const getReportModel = (data) => {







        return (







            data?.output ??







            data?.Output ??







            data?.data ??







            data?.Data ??







            data







        );







    };















    const getRowValue = (row, key) => {







        if (!row) return "";















        const pascalKey =







            key.charAt(0).toUpperCase() +







            key.slice(1);















        return (







            row?.[key] ??







            row?.[pascalKey] ??







            ""







        );







    };















    const getDisplayValue = (







        row,







        key







    ) => {







        const value =







            getRowValue(row, key);















        if (







            value === null ||







            value === undefined







        ) {







            return "";







        }















        if (







            key === "createdDate" &&







            value







        ) {







            const date =







                new Date(value);















            if (







                !Number.isNaN(







                    date.getTime()







                )







            ) {







                return date.toLocaleString(







                    "en-IN",







                    {







                        day: "2-digit",







                        month: "2-digit",







                        year: "numeric",







                        hour: "2-digit",







                        minute: "2-digit",







                    }







                );







            }







        }















        return String(value);







    };















    const getStudentOnlyRows = (rows) => {
        // Backend report procedure already receives the logged-in Student Id.
        // Do not filter again on the frontend because some report result sets
        // either omit StudentId or return it under a different meaning/shape.
        return rows;
    };


    // API model requires these string fields for every report type.
    // Keep existing role-based Id / TeacherId values unchanged.
    const requiredReportIds = {
        StudentId: isStudent && hasStudentId ? String(loggedInStudentId) : "0",
        DistrictId: String(
            sessionStorage.getItem("districtId") ||
            localStorage.getItem("districtId") ||
            getStoredUser()?.districtId ||
            getStoredUser()?.DistrictId ||
            "0"
        ),
    };

    const buildReportRequest = (







        isExportToExcel = false







    ) => ({







        ReportType:







            REPORT_TYPE,















        mode:







            "string",















        Pagination: {







            PageNumber: 1,







            RowsPerPage: 1000,







            SearchTerm: "",







            SortDirection: "DESC",







            SortField: "Id",







        },















        FromDate:







            fromDate,















        ToDate:







            toDate,















        AllRecordsRequired:
            true,















        IsExportToExcel:







            isExportToExcel,















        Id:
            isStudent && hasStudentId
                ? Number(loggedInStudentId)
                : 0,















        Month:







            "",















        // Keep District payload isolated, but satisfy API model validation for all reports.
        ...(REPORT_TYPE === "GetDistrictWiseSchoolReport"
            ? { StudentId: "0", DistrictId: "0" }
            : requiredReportIds),
        TeacherId:
            isSuperAdmin
                ? "0"
                : isTeacher &&
                    hasTeacherId &&
                    numericTeacherId > 0
                    ? String(numericTeacherId)
                    : "0",







    });
















    // ============================================================
    // INITIAL / REPORT CHANGE -> LOAD ALL DATA WITHOUT DATE FILTER
    // ============================================================
    const loadAllReportData = async () => {
        if (
            isTeacher &&
            (
                !hasTeacherId ||
                numericTeacherId <= 0
            )
        ) {
            setError(
                "Valid Teacher Id not found for logged-in teacher. Please ensure login API returns TeacherId."
            );
            setReportData([]);
            setGenerated(true);
            return;
        }

        try {
            setLoading(true);
            setError("");
            setFilters({});
            setShowFilters(true);
            setPageNumber(1);

            const request = {
                ReportType: REPORT_TYPE,
                mode: "string",

                Pagination: {
                    PageNumber: 1,
                    RowsPerPage: 1000,
                    SearchTerm: "",
                    SortDirection: "DESC",
                    SortField: "Id",
                },

                // Load all historical records on initial page load.
                // Backend report query expects valid dates, so use a wide range.
                FromDate: REPORT_TYPE === "GetDistrictWiseSchoolReport" ? fromDate : "1900-01-01",
                ToDate: getTodayValue(),

                AllRecordsRequired: true,
                IsExportToExcel: false,

                Id:
                    isStudent && hasStudentId
                        ? Number(loggedInStudentId)
                        : 0,

                Month: "",

                // Same required API fields on initial load as on Generate/Export.
                ...(REPORT_TYPE === "GetDistrictWiseSchoolReport"
                    ? { StudentId: "0", DistrictId: "0" }
                    : requiredReportIds),

                TeacherId:
                    isSuperAdmin
                        ? "0"
                        : isTeacher &&
                            hasTeacherId &&
                            numericTeacherId > 0
                            ? String(numericTeacherId)
                            : "0",
            };

            console.log("All Report Data Request:", request);

            const response =
                await apiService.post(
                    REPORT_API,
                    request
                );

            const result = response.data;

            const reportModel =
                getReportModel(result);

            const rows =
                reportModel?.reportData ??
                reportModel?.ReportData ??
                [];

            const normalizedRows =
                Array.isArray(rows)
                    ? rows
                    : [];

            const visibleRows =
                getStudentOnlyRows(
                    normalizedRows
                );

            setReportData(visibleRows);
            setGenerated(true);
            setDateFilterApplied(false);

        } catch (apiError) {
            console.error(
                "All Report Data API Error:",
                apiError
            );

            setReportData([]);
            setGenerated(true);
            setDateFilterApplied(false);

            const apiData =
                apiError?.response?.data;

            setError(
                typeof apiData === "string"
                    ? apiData
                    : apiData?.failureReason ??
                      apiData?.FailureReason ??
                      apiData?.message ??
                      apiData?.Message ??
                      apiError?.message ??
                      "Unable to load report data."
            );
        } finally {
            setLoading(false);
        }
    };


    useEffect(() => {
        loadAllReportData();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [REPORT_TYPE]);


    const filteredReportData =







        useMemo(() => {







            return reportData.filter(







                (row) =>







                    REPORT_COLUMNS.every(







                        (column) => {







                            const filterValue =







                                String(







                                    filters[







                                    column.key







                                    ] ?? ""







                                )







                                    .trim()







                                    .toLowerCase();















                            if (!filterValue) {







                                return true;







                            }















                            return String(







                                getDisplayValue(







                                    row,







                                    column.key







                                )







                            )







                                .toLowerCase()







                                .includes(







                                    filterValue







                                );







                        }







                    )







            );







        }, [







            reportData,







            filters,







        ]);















    const totalPages =







        Math.max(







            1,







            Math.ceil(







                filteredReportData.length /







                PAGE_SIZE







            )







        );















    const paginatedReportData =







        useMemo(() => {







            const startIndex =







                (pageNumber - 1) *







                PAGE_SIZE;















            return filteredReportData.slice(







                startIndex,







                startIndex + PAGE_SIZE







            );







        }, [







            filteredReportData,







            pageNumber,







        ]);















    const handleReportChange = (event) => {



        const nextReportType = event.target.value;







        if (isStudent && !STUDENT_REPORT_OPTIONS.includes(nextReportType)) {



            setSelectedReportType("GetAllStudentsReport");



            return;



        }







        setSelectedReportType(nextReportType);



        setGenerated(false);



        setReportData([]);



        setFilters({});



        setShowFilters(true);



        setPageNumber(1);



        setError("");



    };







    const handleGenerate =







        async () => {







            if (!fromDate) {







                setError(







                    "Please select From Date."







                );







                return;







            }















            if (!toDate) {







                setError(







                    "Please select To Date."







                );







                return;







            }















            const today = getTodayValue();

            if (fromDate > today || toDate > today) {
                setError("Future date is not allowed.");
                return;
            }

            if (fromDate > toDate) {







                setError(







                    "From Date cannot be greater than To Date."







                );







                return;







            }















            if (







                isTeacher &&







                (







                    !hasTeacherId ||







                    numericTeacherId <= 0







                )







            ) {







                setError(







                    "Valid Teacher Id not found for logged-in teacher. Please ensure login API returns TeacherId."







                );







                setReportData([]);







                setGenerated(false);







                return;







            }















            try {







                setLoading(true);







                setError("");







                setFilters({});







                setShowFilters(true);







                setPageNumber(1);















                const request =







                    buildReportRequest(false);















                console.log(







                    "Report Request:",







                    request







                );















                const response =







                    await apiService.post(







                        REPORT_API,







                        request







                    );















                const result =







                    response.data;















                console.log(







                    "Report Response:",







                    result







                );















                const reportModel =







                    getReportModel(result);















                const rows =







                    reportModel?.reportData ??







                    reportModel?.ReportData ??







                    [];















                const normalizedRows =







                    Array.isArray(rows)







                        ? rows







                        : [];





















                console.log(







                    "Logged In Role:",







                    loggedInRole







                );















                console.log(







                    "Logged In Teacher Id:",







                    loggedInTeacherId







                );



                console.log("Logged In Student Id:", loggedInStudentId);

                console.log("Is Student:", isStudent);















                console.log(







                    "Is SuperAdmin:",







                    isSuperAdmin







                );















                console.log(







                    "Is Teacher:",







                    isTeacher







                );















                console.log(







                    "Report Data:",







                    normalizedRows







                );















                const visibleRows = getStudentOnlyRows(normalizedRows);



                setReportData(







                    visibleRows







                );















                setGenerated(true);
                setDateFilterApplied(true);







            } catch (apiError) {







                console.error(







                    "Report API Error:",







                    apiError







                );















                setReportData([]);







                setGenerated(false);















                const apiData =







                    apiError?.response?.data;















                console.log(







                    "Report Backend Error:",







                    apiData







                );















                setError(







                    typeof apiData ===







                        "string"







                        ? apiData







                        : apiData?.failureReason ??







                        apiData?.FailureReason ??







                        apiData?.message ??







                        apiData?.Message ??







                        apiError?.message ??







                        "Unable to generate report."







                );







            } finally {







                setLoading(false);







            }







        };















    const handleClear = async () => {
        setFromDate(getMonthStartValue());
        setToDate(getTodayValue());
        setFilters({});
        setShowFilters(true);
        setPageNumber(1);
        setError("");
        setDateFilterApplied(false);

        await loadAllReportData();
    };


    const setColumnFilter = (key, value) => {







        setFilters((previous) => ({







            ...previous,







            [key]: value,







        }));







        setPageNumber(1);







    };















    const handleExport =







        async () => {







            if (!fromDate) {







                setError(







                    "Please select From Date."







                );







                return;







            }















            if (!toDate) {







                setError(







                    "Please select To Date."







                );







                return;







            }















            if (fromDate > toDate) {







                setError(







                    "From Date cannot be greater than To Date."







                );







                return;







            }















            if (







                isTeacher &&







                (







                    !hasTeacherId ||







                    numericTeacherId <= 0







                )







            ) {







                setError(







                    "Valid Teacher Id not found for logged-in teacher. Please ensure login API returns TeacherId."







                );







                return;







            }















            try {







                setError("");



                setNotification(null);















                const request =







                    buildReportRequest(true);















                const response =







                    await apiService.download(







                        REPORT_API,







                        request







                    );















                const blob =







                    response.data instanceof Blob







                        ? response.data







                        : new Blob(







                            [response.data],







                            {







                                type:







                                    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",







                            }







                        );















                const downloadUrl =







                    window.URL.createObjectURL(







                        blob







                    );















                const link =







                    document.createElement(







                        "a"







                    );















                link.href =







                    downloadUrl;















                link.download =







                    `${REPORT_TYPE}.xlsx`;















                document.body.appendChild(







                    link







                );















                link.click();







                link.remove();















                window.URL.revokeObjectURL(







                    downloadUrl







                );







                showNotification(



                    "success",



                    "Report exported successfully."



                );







            } catch (apiError) {







                console.error(







                    "Report Export API Error:",







                    apiError







                );















                const apiData =







                    apiError?.response?.data;















                const message =



                    typeof apiData === "string"



                        ? apiData



                        : apiData?.failureReason ??



                        apiData?.FailureReason ??



                        apiData?.message ??



                        apiData?.Message ??



                        apiError?.message ??



                        "Unable to export report.";







                setError(message);



                showNotification("error", message);







            }







        };















    return (







        <>



            {notification && (



                <div



                    style={{



                        position: "fixed",



                        top: "20px",



                        right: "20px",



                        zIndex: 99999,



                        minWidth: "280px",



                        maxWidth: "420px",



                        padding: "12px 16px",



                        borderRadius: "8px",



                        backgroundColor:



                            notification.type === "success" ? "#d1e7dd" : "#f8d7da",



                        color:



                            notification.type === "success" ? "#0f5132" : "#842029",



                        border:



                            notification.type === "success"



                                ? "1px solid #badbcc"



                                : "1px solid #f5c2c7",



                        fontSize: "14px",



                        fontWeight: 600,



                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",



                    }}



                >



                    {notification.type === "success" ? "✓ " : "✕ "}



                    {notification.message}



                </div>



            )}







            <style>{`







        .report-page {







          width: 100%;







        }















        .report-card {







          background: #fff;







          border: 1px solid #edf0f4;







          border-radius: 10px;







          box-shadow: 0 2px 10px rgba(15, 23, 42, 0.04);







          padding: 22px 24px;







        }















        .report-title {







          display: flex;







          align-items: center;







          gap: 9px;







          font-size: 19px;







          line-height: 1.25;







          font-weight: 700;







          color: #172033;







        }















        .report-title-icon {







          display: inline-flex;







          align-items: center;







          justify-content: center;







          color: #2563eb;







        }















        .report-form-grid {







          display: grid;







          grid-template-columns:







            minmax(220px, 1fr)







            minmax(220px, 1fr)







            minmax(220px, 1fr)







            auto;







          gap: 18px;







          align-items: end;







          margin-top: 26px;







        }















        .report-field {







          min-width: 0;







        }















        .report-label {







          display: flex;







          align-items: center;







          gap: 7px;







          margin-bottom: 8px;







          font-size: 11.5px;







          font-weight: 500;







          color: #475569;







        }















        .report-input {







          width: 100%;







          height: 38px;







          box-sizing: border-box;







          border: 1px solid #dce2ea;







          border-radius: 6px;







          background: #fff;







          padding: 0 11px;







          color: #334155;







          font-size: 12px;







          outline: none;







          transition:







            border-color 0.15s ease,







            box-shadow 0.15s ease;







        }















        .report-input:focus {







          border-color: #2563eb;







          box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.08);







        }















        .report-input[disabled] {







          background: #f5f6f8;







          color: #667085;







          cursor: default;







        }















        .report-actions {







          display: flex;







          align-items: center;







          gap: 8px;







          white-space: nowrap;







        }















        .report-btn {







          height: 38px;







          border-radius: 6px;







          border: 1px solid transparent;







          padding: 0 14px;







          display: inline-flex;







          align-items: center;







          justify-content: center;







          gap: 7px;







          font-size: 11.5px;







          font-weight: 600;







          cursor: pointer;







          transition:







            opacity 0.15s ease,







            background 0.15s ease;







        }















        .report-btn-primary {







          background: #2563eb;







          border-color: #2563eb;







          color: #fff;







        }















        .report-btn-secondary {







          background: #fff;







          border-color: #dce2ea;







          color: #475569;







        }















        .report-btn-filter {







          background: #f1f3f5;







          border-color: #e5e7eb;







          color: #475569;







        }















        .report-btn-export {







          background: #16a34a;







          border-color: #16a34a;







          color: #fff;







        }















        .report-error {







          margin-top: 14px;







          padding: 10px 12px;







          border: 1px solid #fecaca;







          border-radius: 6px;







          background: #fef2f2;







          color: #b91c1c;







          font-size: 11.5px;







        }















        .report-result {







          margin-top: 28px;







        }















        .report-result-head {







          display: flex;







          align-items: flex-end;







          justify-content: space-between;







          gap: 16px;







          margin-bottom: 16px;







        }















        .report-result-title {







          display: flex;







          align-items: center;







          gap: 8px;







          color: #172033;







          font-size: 17px;







          font-weight: 700;







        }















        .report-count {







          margin-top: 4px;







          color: #64748b;







          font-size: 11.5px;







        }















        .report-result-actions {







          display: flex;







          align-items: center;







          gap: 8px;







        }















        .report-table-wrap {







          width: 100%;







          overflow-x: auto;







          border: 1px solid #e3e7ed;







          border-radius: 8px;







          background: #fff;







        }















        .report-table {







          width: 100%;







          min-width: 1280px;







          border-collapse: collapse;







          table-layout: auto;







        }















        .report-table th {







          background: #f8fafc;







          color: #667085;







          text-align: left;







          vertical-align: top;







          border-bottom: 1px solid #e5e7eb;







          padding: 11px 10px 10px;







          font-size: 10px;







          font-weight: 700;







          letter-spacing: 0.04em;







          text-transform: uppercase;







          white-space: nowrap;







        }















        .report-column-label {







          min-height: 18px;







          display: flex;







          align-items: center;







          gap: 5px;







        }















        .report-sort-mark {







          color: #a0a8b5;







          font-size: 11px;







          line-height: 1;







        }















        .report-filter-box {







          margin-top: 7px;







          position: relative;







        }















        .report-filter-box svg {







          position: absolute;







          left: 8px;







          top: 50%;







          transform: translateY(-50%);







          color: #a6afbd;







          pointer-events: none;







        }















        .report-filter-input {







          width: 100%;







          height: 28px;







          box-sizing: border-box;







          border: 1px solid #dce2ea;







          border-radius: 5px;







          background: #fff;







          padding: 0 8px 0 27px;







          color: #475569;







          font-size: 10.5px;







          font-weight: 400;







          text-transform: none;







          letter-spacing: normal;







          outline: none;







        }















        .report-filter-input:focus {







          border-color: #111827;







        }















        .report-table td {







          border-bottom: 1px solid #edf0f4;







          padding: 13px 10px;







          color: #5b6575;







          font-size: 11.5px;







          white-space: nowrap;







        }















        .report-table tbody tr:nth-child(even) {







          background: #fbfcfd;







        }















        .report-table tbody tr:last-child td {







          border-bottom: none;







        }















        .report-empty {







          text-align: center !important;







          color: #94a3b8 !important;







          padding: 30px 12px !important;







        }















        .report-pagination {







          display: flex;







          align-items: center;







          justify-content: flex-end;







          gap: 10px;







          margin-top: 14px;







        }















        .report-pagination-btn {







          height: 34px;







          min-width: 82px;







          border: 1px solid #dce2ea;







          border-radius: 6px;







          background: #fff;







          color: #475569;







          font-size: 11.5px;







          font-weight: 600;







          cursor: pointer;







          padding: 0 12px;







        }















        .report-pagination-btn:hover:not(:disabled) {







          background: #f8fafc;







        }















        .report-pagination-btn:disabled {







          opacity: 0.5;







          cursor: not-allowed;







        }















        .report-pagination-info {







          color: #64748b;







          font-size: 11.5px;







          min-width: 90px;







          text-align: center;







        }















\n        /* School-style pagination: summary and actions stay in one row. */
        .report-pagination {
          width: 100%;
          min-width: 0;
          box-sizing: border-box;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: nowrap;
          gap: 12px;
          margin-top: 16px;
          padding: 12px 4px 4px;
          border-top: 1px solid #eef2f7;
        }
        .report-pagination-count {
          flex: 0 0 auto;
          white-space: nowrap;
          color: #64748b;
          font-size: 11px;
        }
        .report-pagination-count strong { color: #475569; margin: 0 3px; font-weight: 600; }
        .report-pagination-controls {
          display: flex;
          align-items: center;
          justify-content: flex-end;
          flex: 1 1 auto;
          min-width: 0;
          gap: 5px;
        }
        .report-pagination-controls .report-pagination-btn {
          flex: 0 0 auto;
          height: 32px;
          min-width: 66px;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          padding: 0 10px;
          background: #fff;
          color: #475569;
          font-size: 11px;
          font-weight: 500;
          white-space: nowrap;
          cursor: pointer;
        }
        .report-pagination-controls .report-pagination-btn:disabled {
          color: #cbd5e1;
          background: #f8fafc;
          cursor: not-allowed;
        }
        .report-pagination-numbers {
          display: flex;
          align-items: center;
          flex: 0 1 auto;
          min-width: 0;
          gap: 4px;
          overflow-x: auto;
          overflow-y: hidden;
          scrollbar-width: thin;
          padding: 2px 0;
        }
        .report-pagination-number {
          flex: 0 0 auto;
          height: 32px;
          min-width: 32px;
          padding: 0 9px;
          border: 1px solid #e2e8f0;
          border-radius: 6px;
          background: #fff;
          color: #475569;
          font-size: 11px;
          font-weight: 600;
          cursor: pointer;
        }
        .report-pagination-number.active {
          border-color: #2563eb;
          background: #2563eb;
          color: #fff;
        }
        .report-pagination-number:disabled { cursor: not-allowed; }
        @media (max-width: 650px) {
          .report-pagination { gap: 6px; }
          .report-pagination-count { font-size: 10px; }
          .report-pagination-controls { gap: 3px; }
          .report-pagination-controls .report-pagination-btn { min-width: 48px; padding: 0 5px; font-size: 10px; }
          .report-pagination-number { min-width: 28px; height: 30px; padding: 0 6px; }
        }

        @media (max-width: 1100px) {







          .report-form-grid {







            grid-template-columns: repeat(2, minmax(220px, 1fr));







          }















          .report-actions {







            grid-column: 1 / -1;







          }







        }















        @media (max-width: 650px) {







          .report-card {







            padding: 18px 14px;







          }















          .report-form-grid {







            grid-template-columns: 1fr;







          }




          .report-actions {







            grid-column: auto;







            flex-wrap: wrap;







          }



          .report-result-head {







            align-items: flex-start;







            flex-direction: column;







          }







        }







      `}</style>




            <div className="report-page">







                <div className="report-card">







                    <div className="report-title">







                        <span className="report-title-icon">







                            <I n="file" s={21} c="#2563eb" />







                        </span>



                        {REPORT_NAME}







                    </div>



                    <div className="report-form-grid">







                        <div className="report-field">







                            <label className="report-label">







                                Report Name:







                            </label>















                            {reportType ? (
                                <input
                                    className="report-input"
                                    value={REPORT_NAME}
                                    disabled
                                    readOnly
                                />
                            ) : isSuperAdmin || isStudent ? (
                                <select
                                    className="report-input"
                                    value={selectedReportType}
                                    onChange={handleReportChange}
                                >
                                    {(isStudent ? STUDENT_REPORT_OPTIONS : ADMIN_REPORT_OPTIONS).map(
                                        (optionReportType) => (
                                            <option key={optionReportType} value={optionReportType}>
                                                {REPORT_CONFIGS[optionReportType].name}
                                            </option>
                                        )
                                    )}
                                </select>
                            ) : (
                                <input
                                    className="report-input"
                                    value={REPORT_NAME}
                                    disabled
                                    readOnly
                                />
                            )}







                        </div>



                        <div className="report-field">


                            <label className="report-label">



                                <I n="calendar" s={14} c="#64748b" />



                                From Date







                            </label>



                            <input
                                className="report-input"
                                type="date"
                                value={fromDate}
                                max={getTodayValue()}
                                onChange={(event) => {
                                    setFromDate(event.target.value);
                                    setError("");
                                }}
                            />
                        </div>


                        <div className="report-field">







                            <label className="report-label">







                                <I n="calendar" s={14} c="#64748b" />







                                To Date







                            </label>



                            <input
                                className="report-input"
                                type="date"
                                value={toDate}
                                max={getTodayValue()}
                                onChange={(event) => {
                                    setToDate(event.target.value);
                                    setError("");
                                }}
                            />
                        </div>















                        <div className="report-actions">







                            <button







                                type="button"







                                className="report-btn report-btn-primary"







                                onClick={handleGenerate}







                            >







                                <I n="file" s={14} c="#fff" />







                                Generate







                            </button>















                            <button







                                type="button"







                                className="report-btn report-btn-secondary"







                                onClick={handleClear}







                            >







                                <I n="x" s={14} c="#475569" />







                                Clear All







                            </button>







                        </div>







                    </div>















                    {error && (







                        <div className="report-error">







                            {error}







                        </div>







                    )}















                    {generated && (







                        <div className="report-result">







                            <div className="report-result-head">







                                <div>







                                    <div className="report-result-title">







                                        <I n="file" s={19} c="#2563eb" />















                                        <span>







                                            {dateFilterApplied
                                                ? `${REPORT_NAME} (${formatDate(fromDate)} to ${formatDate(toDate)})`
                                                : `${REPORT_NAME} - All Records`}







                                        </span>







                                    </div>















                                    <div className="report-count">







                                        Showing {filteredReportData.length} records







                                    </div>







                                </div>















                                <div className="report-result-actions">







                                    <button







                                        type="button"







                                        className="report-btn report-btn-filter"







                                        onClick={() =>







                                            setShowFilters((previous) => !previous)







                                        }







                                    >







                                        <FilterIcon />







                                        Filters







                                    </button>















                                    <button







                                        type="button"







                                        className="report-btn report-btn-export"







                                        onClick={handleExport}







                                    >







                                        <DownloadIcon />







                                        Export







                                    </button>







                                </div>







                            </div>















                            <div className="report-table-wrap">







                                <table className="report-table">







                                    <thead>







                                        <tr>







                                            {REPORT_COLUMNS.map((column) => (







                                                <th







                                                    key={column.key}







                                                    style={{







                                                        minWidth: column.minWidth,







                                                    }}







                                                >







                                                    <div className="report-column-label">







                                                        {column.label}







                                                        <span className="report-sort-mark">







                                                            ⌃







                                                        </span>







                                                    </div>















                                                    {showFilters && !(isStudent && (column.key === "studentName" || column.key === "schoolName")) && (







                                                        <div className="report-filter-box">







                                                            <FilterIcon size={12} />















                                                            <input







                                                                className="report-filter-input"







                                                                value={filters[column.key] || ""}







                                                                onChange={(event) =>







                                                                    setColumnFilter(







                                                                        column.key,







                                                                        event.target.value







                                                                    )







                                                                }







                                                                placeholder="Filter..."







                                                            />







                                                        </div>







                                                    )}







                                                </th>







                                            ))}







                                        </tr>







                                    </thead>















                                    <tbody>







                                        {filteredReportData.length === 0 ? (







                                            <tr>







                                                <td







                                                    className="report-empty"







                                                    colSpan={REPORT_COLUMNS.length}







                                                >







                                                    No records found







                                                </td>







                                            </tr>







                                        ) : (







                                            paginatedReportData.map(







                                                (row, rowIndex) => (







                                                    <tr







                                                        key={







                                                            row?.id ??







                                                            row?.Id ??







                                                            `${getRowValue(row, "studentName") ||



                                                            getRowValue(row, "teacherName")}-${getRowValue(row, "bookName") ||



                                                            getRowValue(row, "examName")}-${getRowValue(



                                                                row,



                                                                "createdDate"



                                                            )}-${rowIndex}`







                                                        }







                                                    >







                                                        {REPORT_COLUMNS.map(







                                                            (column) => (







                                                                <td







                                                                    key={







                                                                        column.key







                                                                    }







                                                                >







                                                                    {getDisplayValue(







                                                                        row,







                                                                        column.key







                                                                    )}







                                                                </td>







                                                            )







                                                        )}







                                                    </tr>







                                                )







                                            )







                                        )}







                                    </tbody>







                                </table>







                            </div>















                            <div className="report-pagination" aria-label="Report pagination">
                                <div className="report-pagination-count">
                                    Showing <strong>{filteredReportData.length === 0 ? 0 : (pageNumber - 1) * PAGE_SIZE + 1}</strong>
                                    –<strong>{Math.min(pageNumber * PAGE_SIZE, filteredReportData.length)}</strong>
                                    of <strong>{filteredReportData.length}</strong>
                                </div>
                                <div className="report-pagination-controls">
                                    <button type="button" className="report-pagination-btn"
                                        disabled={pageNumber <= 1 || loading}
                                        onClick={() => setPageNumber((previous) => Math.max(1, previous - 1))}>
                                        <span aria-hidden="true">‹</span> Back
                                    </button>
                                    <div className="report-pagination-numbers" aria-label="Page numbers">
                                        {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
                                            <button key={page} type="button"
                                                className={`report-pagination-number${page === pageNumber ? " active" : ""}`}
                                                aria-label={`Go to page ${page}`}
                                                aria-current={page === pageNumber ? "page" : undefined}
                                                disabled={loading}
                                                onClick={() => setPageNumber(page)}>
                                                {page}
                                            </button>
                                        ))}
                                    </div>
                                    <button type="button" className="report-pagination-btn"
                                        disabled={pageNumber >= totalPages || loading}
                                        onClick={() => setPageNumber((previous) => Math.min(totalPages, previous + 1))}>
                                        Next <span aria-hidden="true">›</span>
                                    </button>
                                </div>
                            </div>







                        </div>







                    )}







                </div>







            </div>







        </>







    );







}
